import { render, staticRenderFns } from "./StockRelateTasksList.vue?vue&type=template&id=912161a6&"
import script from "./StockRelateTasksList.vue?vue&type=script&lang=js&"
export * from "./StockRelateTasksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports